import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=23d8ef2c&scoped=true&"
import script from "./Discover.vue?vue&type=script&lang=js&"
export * from "./Discover.vue?vue&type=script&lang=js&"
import style0 from "./Discover.vue?vue&type=style&index=0&id=23d8ef2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d8ef2c",
  null
  
)

export default component.exports